export default class SelectionsController {

    constructor($scope, $rootScope, ApiSelections, $ionicLoading, $q, $ionicScrollDelegate) {
        this.ApiSelections = ApiSelections;
        this.$ionicLoading = $ionicLoading;
        this.selections = [];
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.isFilterApplied = false;

        this.selectionsPromise = $q.defer();
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    init(assignedPackageFilter, pullToRefresh) {

        if (!pullToRefresh) {
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
            });
        }

        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
            duration: 1000
        });

        var teaserPackageFilter = {};
        teaserPackageFilter.teaserPackage = true;
        this.ApiSelections.getSelectionsFiltered(teaserPackageFilter).then((res) => {
          this.teaserPackages = res;
        })
        .catch(() => {
            this.$ionicLoading.hide();
            this.$scope.$broadcast('scroll.refreshComplete');
        });

        assignedPackageFilter.teaserPackage = false;
        this.ApiSelections.getSelectionsFiltered(assignedPackageFilter).then((res) => {
            this.selections = res;
            this.selectionsPromise.resolve(res);
        })
        .catch(() => {
            this.$ionicLoading.hide();
            this.$scope.$broadcast('scroll.refreshComplete');
        });

        this.ApiSelections.getPurchasedTeamSelections().then((res) => {
            this.selectionsPurchased = res;
            this.selections.loaded = true;
            this.$ionicLoading.hide();
            this.$scope.$broadcast('scroll.refreshComplete');
        })
        .catch(() => {
            this.$ionicLoading.hide();
            this.$scope.$broadcast('scroll.refreshComplete');
        });

    }

    setSearchPerformedSignal() {

        this.$ionicScrollDelegate.scrollTop();
        this.$rootScope.$broadcast('searchPerformed');
    };

}



/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selections.controller.js
 **/